import React from "react";
import { Form } from "react-bootstrap";

const RadioGroup = ({ options = [], value, onChange, name }) => {
    return (
        <div style={{ display: "flex", gap: "1rem", flexWrap: "wrap" }}>
            {options.map((option, idx) => (
                <Form.Check
                    key={idx}
                    type="radio"
                    name={name}
                    label={option.label}
                    value={option.value}
                    checked={value === option.value}
                    onChange={() => onChange(option.value)}
                />
            ))}
        </div>
    );
};

export default RadioGroup;
